import moment from 'moment';
// Get visible expenses

export default (expenses, { text = '', sortBy = 'date', startDate = undefined, endDate = undefined } = {}) => {

    const [description, otherExpenses] = expenses
    console.log("Typeof: ", typeof description)
    console.log(description.description)
    let uniqueExpenses = []
    expenses.map((expense) => {
        uniqueExpenses.push(expense.description)

    })

    uniqueExpenses.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
    })

    return [...new Set(uniqueExpenses)]


};




// WEBPACK FOOTER //
// ./src/selectors/expenses-unique.js